if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.updateImageSizes = this.updateImageSizes.bind(this);
      }

      hide() {
        window.removeEventListener('resize', this.updateImageSizes);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        window.addEventListener('resize', this.updateImageSizes, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.updateImageSizes);
      }

      updateImageSizes() {
        if (!this.hasAttribute('open')) return;
        this.querySelectorAll('img[data-media-id]').forEach((image) => {
          // Measure the zoom itself, not the gallery thumbnail or the root font size.
          const width = Math.ceil(image.getBoundingClientRect().width);
          if (width > 0) image.sizes = width + 'px';
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.updateImageSizes();
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
